import React from 'react';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { Spacing } from '../../layout/Spacing/Spacing';
import { TextCustom } from '../../ui/TextCustom';
import { Loader } from '../Loader/Loader';

interface ILoaderForModalProps {
    size?: number;
    label?: string;
}

export const LoaderForModal: React.FC<ILoaderForModalProps> = ({ size = 30, label = 'please provide some text' }) => {
    return (
        <Spacing marginSpacing={'none'} paddingSpacing={'xl'}>
            <FlexCenter gap={1} direction="h" position="center">
                <Loader color="accent-green" height={size} width={size} />
                <TextCustom size={2} color="dark">
                    {label}
                </TextCustom>
            </FlexCenter>
        </Spacing>
    );
};
